import Typography from '@mui/material/Typography';
import { ChatMessage } from '../../ChatMessage/ChatMessage';

type ErrorMessageProps = {
  errorMessage?: string;
};

export const ErrorMessage = ({ errorMessage }: ErrorMessageProps) => {
  return (
    <ChatMessage>
      <Typography
        variant="body2"
        color="error"
        sx={{
          fontSize: 15,
          fontWeight: theme => theme.typography.fontWeightBold,
        }}
      >
        {errorMessage}
      </Typography>
    </ChatMessage>
  );
};
